import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  appMode: 'retailer',
  checkedToken: false,
  invalidPwResetToken: null,
  token: null,
  user: null,
  dateRange: [],
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCheckToken: (state, action) => {
      state.checkedToken = action.payload; // Store API data
    },
    setInvalidPwResetToken: (state, action) => {
      state.invalidPwResetToken = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload; // Store API data
    },
    setUser: (state, action) => {
      state.user = action.payload; // Store API data
    },
    setDateRange: (state, action) => {
      state.dateRange = action.payload; // Store date range data
    },
    setAppMode: (state, action) => {
      state.appMode = action.payload;
    },
    clearUser: state => {
      state.user = null;
      state.token = null;
    },
    clearInvalidPwResetToken: state => {
      state.invalidPwResetToken = null;
    },
  },
});

export const {
  setCheckToken,
  setInvalidPwResetToken,
  setToken,
  setUser,
  setDateRange,
  setAppMode,
  clearUser,
  clearInvalidPwResetToken,
} = appSlice.actions;
export default appSlice.reducer;

// Selectors
export const getToken = state => state.app.token;
